var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6838 7.59092C13.473 7.37878 13.2174 7.27279 12.9163 7.27279H12.5554V5.09085C12.5554 3.69693 12.059 2.50007 11.0659 1.50007C10.0728 0.500022 8.8844 0 7.49994 0C6.11553 0 4.92684 0.500022 3.93389 1.50003C2.94077 2.50007 2.44437 3.69689 2.44437 5.09085V7.27279H2.08331C1.78248 7.27279 1.52664 7.37878 1.31597 7.59092C1.1053 7.8029 1 8.06054 1 8.36374V14.9091C1 15.2121 1.10533 15.4698 1.31597 15.6819C1.52664 15.8939 1.78248 16 2.08331 16H12.9166C13.2176 16 13.4733 15.894 13.684 15.6819C13.8945 15.4698 14 15.2121 14 14.9091V8.36362C14.0002 8.06066 13.8945 7.80306 13.6838 7.59092ZM10.3888 7.27279H4.61107V5.09085C4.61107 4.28786 4.89325 3.60221 5.45747 3.03412C6.02177 2.46596 6.70256 2.18194 7.50006 2.18194C8.29764 2.18194 8.97827 2.46592 9.54261 3.03412C10.1067 3.60217 10.3888 4.28786 10.3888 5.09085V7.27279Z",
    fill: "#FF5959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.88bca81714ec789e7ed776b5b7ef4f51.svg";
export { ForwardRef as ReactComponent };